import { LockOutlined, UserOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Spin,
  message,
  Typography,
  Space,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import apiAuth from "constants/api/apiAuth";
import setAuthorizationHeader from "configs/axios/setAuthorizationHeader";
import useAuth from "utils/auth/hooks";
import * as ls from "utils/localStorage";
import { Footer } from "antd/lib/layout/layout";
import matahariLogo from "assets/images/mataharilogo.png";
import ForgotPasswordForm from "./ForgotPasswordForm";

const { Content } = Layout;
const { Text } = Typography;

function Login() {
  const { methods } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const version = ls.load("api-version");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onFinish = (values) => {
    setIsLoading(true);
    apiAuth
      .login(values)
      .then((res) => {
        if (res.success) {
          setAuthorizationHeader(res.result.token);
          methods.handleLogin(res.result);
        } else {
          message.error(res.message, 3);
        }
        setIsLoading(false);
      })
      .catch(() => {
        message.error("Network unstable", 3);
        setIsLoading(false);
      });
  };

  return (
    <Layout>
      <Content>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
          <Col>
            <Spin spinning={isLoading}>
              <div style={{height:'60px', width:'100%', marginBottom:'8px'}}>
                <img src={matahariLogo} style={{height:'100%', width:'100%', objectFit:'contain' }} />
              </div>
              <Card title="Login" bordered={false}>
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined className="site-form-item-icon" />}
                      placeholder="Email"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="Password"
                    />
                  </Form.Item>
                  <Form.Item>
                    <a
                      className="login-form-forgot"
                      onClick={() => setIsModalVisible(true)}
                    >
                      <b>Forgot password?</b>
                    </a>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      block
                    >
                    Log in
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Spin>
            <Footer style={{ textAlign: "center" }}>
              <Space direction="vertical">
                <Text code>{`Version ${version ?? "2.0.0"}`}</Text>
                {"© Matahari Department Store, 2021"}
              </Space>
            </Footer>
          </Col>
        </Row>
        <Modal
          visible={isModalVisible}
          title="Forgot Password"
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <ForgotPasswordForm onFinish={() => setIsModalVisible(false)} />
        </Modal>
      </Content>
    </Layout>
  );
}

export default Login;
